import {
 Box,
 Button,
 IconButton,
 InputAdornment,
 OutlinedInput,
 SvgIcon,
 Tooltip,
 Typography,
} from '@mui/material';
import { usersGenerateApiKeyStart } from '../../redux/users/usersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';
import { UsersDTO } from '@redux/users/usersTypes';
const CopyIcon = () => (
 <SvgIcon fontSize="small">
  <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
 </SvgIcon>
);

const CheckIcon = () => (
 <SvgIcon fontSize="small" color="success">
  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
 </SvgIcon>
);

const GenerateAPIKey = ({ user }: { user: UsersDTO }) => {
 const dispatch = useDispatch();
 const { t } = useTranslation();
 const { apiKey, loading } = useSelector((state: RootState) => state.users);
 const [copied, setCopied] = useState(false);
 const isGenerating = !!loading?.usersGenerateApiKey;

 const handleCopy = () => {
  if (!apiKey) return;
  navigator.clipboard.writeText(apiKey);
  setCopied(true);
  setTimeout(() => setCopied(false), 2000);
 };

 const handleGenerate = () => {
  dispatch(usersGenerateApiKeyStart({ userId: user.Id || '' }));
 };

 const apiKeyMerge = apiKey || user.ApiKey;

 return (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
   <Typography sx={{ fontSize: 14, fontWeight: 500, mb: 1 }}>
    {t('user.sidebar.apiKey.title')}
   </Typography>
   {apiKeyMerge ? (
    <OutlinedInput
     value={apiKeyMerge}
     readOnly
     fullWidth
     size="small"
     disabled={isGenerating}
     sx={{ fontFamily: 'monospace', pr: 0.5 }}
     endAdornment={
      <InputAdornment position="end">
       <Tooltip
        title={
         copied
          ? t('user.sidebar.apiKey.copied')
          : t('user.sidebar.apiKey.copyApiKey')
        }
       >
        <IconButton
         onClick={handleCopy}
         edge="end"
         aria-label={t('user.sidebar.apiKey.copyApiKey')}
         size="small"
         disabled={isGenerating}
        >
         {copied ? <CheckIcon /> : <CopyIcon />}
        </IconButton>
       </Tooltip>
      </InputAdornment>
     }
    />
   ) : (
    <Button
     variant="outlined"
     color="primary"
     size="large"
     sx={{
      mt: '20px',
      width: '100%',
      background: (theme: Theme) => theme.palette.kemek.lightBlue,
     }}
     disabled={isGenerating}
     onClick={handleGenerate}
    >
     {isGenerating
      ? t('user.sidebar.apiKey.generating')
      : apiKey
      ? t('user.sidebar.apiKey.generateAnotherKey')
      : t('user.sidebar.apiKey.generateApiKey')}
    </Button>
   )}
  </Box>
 );
};

export default GenerateAPIKey;
